import TokenService from '@/scripts/services/base/token.service'

import EntityTypes from '@/scripts/enums/entityTypes.enum'
//import JobRoles from "@/scripts/enums/jobRoles.enum";

export default {
    namespaced: true,
    state: {
        isAgent: null,
        permissions: [],
        loggedEntityId: 0
    },
    mutations: {
        SET_PERMISSIONS: function(state, permissions) {
            state.permissions = permissions
        },
        SET_IS_AGENT: function(state, isAgent) {
            state.isAgent = isAgent
        },
        SET_LOGGED_ENTITY_ID: function (state, loggedEntityId) {
            state.loggedEntityId = loggedEntityId
        }
    },
    actions: {
        setPermissions(context, permissions) {
            context.commit('SET_PERMISSIONS', permissions)
            // var permissionData = { 'entityType': permissions[0].entityViewModel.entityType,  'isAdmin': permissions[0].entityViewModel.entityType};
            // TokenService.savePermission(permissions[0])
        },
        setIsAgent(context, isAgent) {
            context.commit('SET_IS_AGENT', isAgent)
            TokenService.saveIsAgent(isAgent)
        },
        setLoggedEntityId(context, loggedEntityId) {
            context.commit('SET_LOGGED_ENTITY_ID', loggedEntityId)
            TokenService.SaveLoggedEntityId(loggedEntityId)
        },
    },
    getters: {
        isAgent: (state) => {
            if (state.isAgent == null) {
                state.isAgent = TokenService.getIsAgent()
            }
            return state.isAgent
        },
        loggedEntityId: (state) => {
            if(!state.loggedEntityId){
                state.loggedEntityId = TokenService.GetLoggedEntityId()
            }
            return state.loggedEntityId
        },
        getTypeOfLoggedEntity: (state) => {
            const result =  state.permissions.find(
                (p) => p.entityViewModel.id = state.loggedEntityId
            )
            return result.entityViewModel.entityType
        },
        hasSecretaryManagementPermission: (state) => {
            // return true || state
            if (
                state.permissions &&
                state.permissions.find(
                    (p) => p.entityViewModel.entityType == EntityTypes.Benefactor
                )
            )
                return true
            return false
        },
        hasCouncilManagementPermission: (state) => {
            // return true || state
            if (
                state.permissions &&
                state.permissions.find(
                    (p) => p.entityViewModel.entityType == EntityTypes.Benefactor
                )
            )
                return true
            return false
        },
        hasInstitutionManagementPermision: (state) => {
            // return true || state
            if (
                state.permissions &&
                state.permissions.find(
                    (p) =>
                        p.entityViewModel.entityType == EntityTypes.Benefactor ||
                        p.entityViewModel.entityType == EntityTypes.Council
                )
            )
                return true
            return false
        },
        hasCouncilEntityManagementPermission: (state, entityId) => {
            // return true || state
            console.log(entityId)
            if (
                state.permissions &&
                state.permissions.find(
                    (p) =>
                        p.entityViewModel.entityType == EntityTypes.Benefactor ||
                        (p.entityViewModel.entityType == EntityTypes.Council && p.entityViewModel.Id == entityId && p.admin)
                )
            )
                return true
            return false
        },
        hasUserManagementPermission: (state) => {
            // return true || state
            if (
                state.permissions &&
                state.permissions.find(
                    (p) =>
                        p.admin ||
                        p.entityViewModel.entityType == EntityTypes.Benefactor
                )
            )
                return true
            return false
        },
        hasAgentManagementPermission: (state) => {
            // return true || state
            if (
                state.permissions &&
                state.permissions.find(
                    (p) =>
                        p.entityViewModel.entityType == EntityTypes.Benefactor ||
                        (p.entityViewModel.entityType == EntityTypes.Council &&
                            p.admin)
                )
            )
                return true
            return false
        },
        hasFinancialPersmission: (state) => {
            // return true || state
            if (
                state.permissions &&
                state.permissions.find(
                    (p) =>
                        p.entityViewModel.entityType == EntityTypes.Benefactor ||
                        (p.entityViewModel.entityType == EntityTypes.Council &&
                            p.admin) ||
                        (p.entityViewModel.entityType == EntityTypes.Council &&
                            p.finance)
                )
            )
                return true
            return false
        },
        hasReceiptPermission: (state) => {
            if (
                state.permissions &&
                state.permissions.find(
                    (p) =>
                        p.entityViewModel.entityType == EntityTypes.Benefactor ||
                        (p.entityViewModel.entityType == EntityTypes.Council && p.admin)
                )
            )
                return true
            return false
            //return true || state
        },
        hasDashboardPermission: () => {
            return true
        },
        isBenefactor: (state) => {
            let isBenefector = false;
            state.permissions.forEach(permission => {
                if(permission && permission.entityViewModel.entityType == EntityTypes.Benefactor){
                    isBenefector = true;
                }
            })
            return isBenefector;
        },
        isAdminOrBenefactor: (state) => {
            const permission = state.permissions[0];

            if(!permission) {
                return false;
            }
                    
            return permission.admin || permission.entityViewModel.entityType == EntityTypes.Benefactor;
        },
        isAdminOfLoggedCouncilOrBenefactor: (state) => {
            let isAllow = false;
            state.permissions.forEach(permission => {
                console.log(permission)
                if(permission && (permission.entityViewModel.entityType == EntityTypes.Benefactor || (permission.entityViewModel.entityType == EntityTypes.Council
                && permission.entityViewModel.id == state.loggedEntityId && permission.admin))) {
                    isAllow = true
                }
            })
            return isAllow;
        }
    },
}
